import template from './new-normal-theme.html';
import themes from '../themes/themes';

export default {
	name: 'NewNormalTheme',
	template,
	props: ['theme', 'data', 'backgroundUrl', 'fontFamily'],
	data () {
		return {
			themes
		};
	}
};
